import { useSyncExternalStore } from 'react';
import { Modal, Pressable, View } from 'react-native';
import { colors } from '@hogar/shared';
import { Txt } from './ui';

/**
 * Confirmations and notices drawn by the app itself in the browser. The browser's own boxes
 * (window.confirm and alert) can be blocked silently: iPhone Safari after "don't allow more
 * dialogs," and the browsers inside WhatsApp or Instagram. Then a tap on "Delete" did nothing.
 */
interface Dialog {
  message: string;
  yes: string;
  no?: string;
  resolve: (ok: boolean) => void;
}
let queue: Dialog[] = [];
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function showDialog(d: Dialog) {
  queue = [...queue, d];
  emit();
}

export function DialogHost() {
  const current = useSyncExternalStore((l) => (listeners.add(l), () => listeners.delete(l)), () => queue[0]);
  if (!current) return null;
  const close = (ok: boolean) => {
    queue = queue.slice(1);
    emit();
    current.resolve(ok);
  };
  return (
    <Modal visible transparent animationType="fade" onRequestClose={() => close(false)}>
      <View style={{ flex: 1, backgroundColor: 'rgba(43,53,48,0.45)', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <View style={{ width: '100%', maxWidth: 360, backgroundColor: colors.card, borderRadius: 18, padding: 20, gap: 18 }}>
          <Txt size={16}>{current.message}</Txt>
          <View style={{ flexDirection: 'row', gap: 10, justifyContent: 'flex-end' }}>
            {current.no && (
              <Pressable onPress={() => close(false)} style={{ minHeight: 44, paddingHorizontal: 18, borderRadius: 12, borderWidth: 1.5, borderColor: colors.cardBorder, justifyContent: 'center' }}>
                <Txt weight="medium">{current.no}</Txt>
              </Pressable>
            )}
            <Pressable onPress={() => close(true)} style={{ minHeight: 44, paddingHorizontal: 18, borderRadius: 12, backgroundColor: colors.primary, justifyContent: 'center' }}>
              <Txt weight="semibold" color={colors.white}>
                {current.yes}
              </Txt>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}
